/**
 * 预加载所有图片（首页 + 弹框）
 * @returns {Promise} 所有图片加载完成的 Promise
 */
export function preloadAllImages() {
  const imageList = [
    // ========== 首页图片 ==========
    // 背景图
    require('@/assets/imgs/xibNewCustomerGift/bg.png'),
    
    // 领取按钮
    require('@/assets/imgs/xibNewCustomerGift/signUpBtnBg1.png'),
    require('@/assets/imgs/xibNewCustomerGift/signUpBtnBg2.png'),
    require('@/assets/imgs/xibNewCustomerGift/signUpBtnBg3.png'),
    
    // 权益列表背景
    require('@/assets/imgs/xibNewCustomerGift/eqBg1.png'),
    
    // 档位标题背景（4 个档位）
    require('@/assets/imgs/xibNewCustomerGift/eqHeader1.png'),
    require('@/assets/imgs/xibNewCustomerGift/eqHeader2.png'),
    require('@/assets/imgs/xibNewCustomerGift/eqHeader3.png'),
    require('@/assets/imgs/xibNewCustomerGift/eqHeader4.png'),
    
    // 权益选项背景
    require('@/assets/imgs/xibNewCustomerGift/eqBg2.png'),
    require('@/assets/imgs/xibNewCustomerGift/eqBg4.png'),
    
    // 图标
    require('@/assets/imgs/xibNewCustomerGift/wx.png'),
    require('@/assets/imgs/xibNewCustomerGift/jf.png'),
    
    // 功能按钮（规则、记录）
    require('@/assets/imgs/xibNewCustomerGift/ruleBg.png'),
    require('@/assets/imgs/xibNewCustomerGift/recordBg.png'),

    // ========== 规则弹框图片 ==========
    // ruleModal 背景（如果有）
    // require('@/assets/imgs/xibNewCustomerGift/ruleModalBg.png'),

    // ========== 领取弹框图片 ==========
    require('@/assets/imgs/xibNewCustomerGift/rewardBg.png'),
    require('@/assets/imgs/xibNewCustomerGift/rewardBtn.png'),
    // require('@/assets/imgs/xibNewCustomerGift/rewardWx.png'),
    // require('@/assets/imgs/xibNewCustomerGift/rewardJf.png'),
    require('@/assets/imgs/xibNewCustomerGift/rewardWxBg.png'),

    // ========== 记录弹框图片 ==========
    require('@/assets/imgs/xibNewCustomerGift/recordModalBg.png'),
  ]

  // 预加载所有图片
  const promises = imageList.map(src => {
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = () => {
        // console.log('✅ 图片加载成功:', src.split('/').pop())
        resolve(src)
      }
      img.onerror = () => {
        // console.warn('❌ 图片加载失败:', src.split('/').pop())
        resolve(src) // 失败也继续，避免阻塞
      }
      img.src = src
    })
  })

  return Promise.all(promises)
}